import React from "react";
import type { ComponentProps } from "react";
import { SimpleFormIterator } from "react-admin";
import { Button } from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";

type ReusableIteratorProps = ComponentProps<typeof SimpleFormIterator> & {
  children: React.ReactNode;
  addButtonText?: string;
};

export const IndexLabelSimpleFormIterator: React.FC<ReusableIteratorProps> = ({
  children,
  addButtonText,
  ...iteratorProps
}) => {
  return (
    <SimpleFormIterator
      addButton={
        <Button startIcon={<AddCircleIcon />} color="primary">
          {addButtonText ? addButtonText : "追加"}
        </Button>
      }
      removeButton={
        <Button startIcon={<RemoveCircleIcon />} color="error">
          削除
        </Button>
      }
      disableReordering={true}
      disableClear
      getItemLabel={(index: number) => `${index + 1}`}
      sx={{
        "& .RaSimpleFormIterator-index": {
          marginRight: 4,
        },
        "& .RaSimpleFormIterator-line": {
          "& .RaSimpleFormIterator-action": {
            marginLeft: "16px",
            visibility: "visible !important",
          },
        },
      }}
      {...iteratorProps}
    >
      {children}
    </SimpleFormIterator>
  );
};
